import React, {ComponentType} from "react";
import Cookies from 'universal-cookie';
import {authApiService} from "../services/amartaVip/AuthApiService";

export default function withAuth<P extends object>(Component: ComponentType<P>, pageCode?: any) {
    const cookies = new Cookies();

    class InnerHoc extends React.Component<any, any> {
        constructor(props: any) {
            super(props);

            this.state = {
                authenticated: false,
                authenticating: true,
            }
        }

        checkAuth = async () => {
            await this.promisedSetState({
                authenticating: true,
            });

            let currentState = {...this.state};
            const token = cookies.get('_tc-t');
            if (!token) {
                currentState.authenticated = false;
            } else {
                await authApiService.setToken(token);
                try {
                    await authApiService.checkJwt();
                    currentState.authenticated = true;
                } catch (e) {
                    currentState.authenticated = false;
                }
            }
            currentState.authenticating = false;
            await this.promisedSetState({...currentState});
        }

        componentDidMount = () => {
            this.checkAuth().then();
        };

        promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

        render = () => {
            if (this.state.authenticating) {
                return <span>Authenticating...</span>
            } else {
                if (this.state.authenticated) {
                    return (<Component {...this.props as P}/>)
                } else {
                    cookies.remove('_tc-t');
                    cookies.remove('_tc-n');
                    cookies.remove('_tc-p');
                    cookies.remove('_tc-e');
                    cookies.remove('_tc-ut');
                    cookies.remove('_tc-uc');
                    cookies.remove('_tc-ui');
                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 200);
                }
            }
        };
    }

    return InnerHoc;
}
